import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import BaseFormContainer from '../../common/components/form/BaseFormContainer';

import { getCurrentUser } from '../user.selectors';

import * as userActions from '../user.actions';
import * as ActionTypes from '../user.actionTypes';
import ChangePasswordForm from './ChangePasswordForm';
import Button from '../../../ui/button/Button';
import colorThemes from '../../../ui/colorThemes';
import { Localize } from '../../../locale/localization';

const constraints = {
  oldPassword: {
    presence: {
      message: `^${Localize('form.change-password.old-password.error')}`
    }
  },
  newPassword: {
    presence: {
      message: `^${Localize('form.change-password.new-password.error')}`
    }
  },
  newPasswordConfirm: {
    presence: {
      message: `^${Localize('form.change-password.new-password-confirm.error')}`
    },
    equality: {
      attribute: "newPassword",
      message: `^${Localize('form.change-password.new-password-equality.error')}`
    }
  },
};

const baseFormData = {
  oldPassword: '',
  newPassword: '',
  newPasswordConfirm: '',
};

class ChangePasswordFormContainer extends BaseFormContainer {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      formData: Object.assign({}, baseFormData),
    };
  }

  getConstraints = () => constraints;

  doSubmit = (formData) => {
    const { currentUser, changePassword } = this.props;
    const {
      _id,
    } = currentUser;

    changePassword({
      ...formData,
      _id,
    }).then((action) => {
      if(action && action.type === ActionTypes.CHANGE_PASSWORD_SUCCESS) {
        this.setState({
          submitCompleted: true,
          submitted: true,
        });
      } else {
        this.setState({
          submitFailed: true,
          submitted: true,
        });
      }
    });
  }

  onCancel = (event) => {
    event.preventDefault();
    
    const { cancelPath, history } = this.props;
    history.replace(cancelPath);
  }

  onReset = (event) => {
    event.preventDefault();
    this.reset();
    this.setState({
      formData: Object.assign({}, baseFormData),
    });
  }

  render() {
    return (
      !this.state.submitted ? (
        <ChangePasswordForm
          enabled={!this.state.isSubmitting}
          onSubmit={this.onSubmit}
          onCancel={this.onCancel}
          onInputChange={this.onInputChange}
          onBlur={this.onBlur}
          errors={this.state.errors}
          touchedFields={this.state.touchedFields}
          isValid={this.state.isValid}
          oldPassword={this.state.formData.oldPassword}
          newPassword={this.state.formData.newPassword}
          newPasswordConfirm={this.state.formData.newPasswordConfirm}
        />
      ) : (
        this.state.submitCompleted ? (
          <div>
            <p>Salasana vaihdettu onnistuneesti.</p>
            <Button theme={colorThemes.LIGHT} onClick={this.onCancel}>Sulje</Button>
          </div>
        ) : (
          <div>
            <p>Salasanan vaihto ei onnistunut.</p>
            <Button theme={colorThemes.LIGHT} onClick={this.onReset}>Yritä uudelleen</Button>
          </div>
        )
      )
    );
  }
}

const mapStateToProps = (state, { cancelPath }) => {
  const currentUser = getCurrentUser(state);

  return {
    currentUser,
    cancelPath,
  };
};

const ConnectedChangePasswordFormContainer = connect(
  mapStateToProps,
  userActions,
)(ChangePasswordFormContainer);

export default withRouter(ConnectedChangePasswordFormContainer);


// WEBPACK FOOTER //
// ./src/modules/user/components/ChangePasswordFormContainer.js